/* eslint-disable react/display-name */

import styled, { css } from 'styled-components';

import { FCWithChildren } from 'common/types';
import { LegacySpacing } from 'theme/legacyTheme';

import { BaseElementProps, CardProps, HeaderFooterProps } from './types';

// The BaseElement requires padding
const BaseElement = styled.div<BaseElementProps>`
  padding: ${({ padding, theme }): string =>
    (Array.isArray(padding) ? padding : padding.split(' '))
      .map((value) =>
        value === '0' ? '0' : `${theme.spacings[value as LegacySpacing]}px`,
      )
      .join(' ')};
`;

// TODO(Achille): Animate in/out the presence the shadow
// TODO(Matthieu): `overflow: hidden` can cause issues with child elements which are expected to overflow such as dropdowns. Investigate into whether or not it's required here.
export const cardMixin = css<CardProps>`
  background-color: white;
  border-radius: ${({ theme }) => theme.spacings.abs8}px;
  ${({ shadow = 1 }): string =>
    `box-shadow: 0px ${2 * shadow}px ${
      6 * shadow
    }px rgba(0, 0, 0, 0.07), 0px 0px ${2 * shadow}px rgba(0, 0, 0, 0.1);`}
`;

export const Wrapper = styled.div<CardProps>`
  ${cardMixin}
`;

// Returns a React Function component
// whichs accepts a padding prop, but does not require it
// It wraps BaseElement, providing a default padding value
// if none is provided
const getBaseElementWithDefaultPadding =
  (
    defaultPadding: BaseElementProps['padding'],
  ): FCWithChildren<HeaderFooterProps> =>
  ({ padding = defaultPadding, ...props }): ReturnType<typeof BaseElement> => (
    <BaseElement padding={padding} {...props} />
  );

const HeaderOrFooterMixin = css<HeaderFooterProps>`
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.grey(3)};
  ${({ noBackground, theme }) =>
    noBackground ? '' : `background-color: ${theme.colors.grey(3)}`};
`;

const HeaderOrFooter = styled(
  getBaseElementWithDefaultPadding(['abs16', 'abs24']),
)<HeaderFooterProps>`
  ${HeaderOrFooterMixin}
`;

export const Header = styled(HeaderOrFooter)`
  border-width: 0 0 1px;
  border-top-left-radius: ${({ theme }) => theme.spacings.abs8}px;
  border-top-right-radius: ${({ theme }) => theme.spacings.abs8}px;
`;

export const Body = styled(
  getBaseElementWithDefaultPadding(['abs32', 'abs24']),
)``;

export const Footer = styled(HeaderOrFooter)`
  border-width: 1px 0 0;
  border-bottom-right-radius: ${({ theme }) => theme.spacings.abs8}px;
  border-bottom-left-radius: ${({ theme }) => theme.spacings.abs8}px;
`;
